import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const EditServicesFive = () => {
    const { id } = useParams();
    const [item, setItem] = useState([]);

    useEffect(() => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/service-item-five/${id}`)
            .then((res) => res.json())
            .then((info) => setItem(info));
    }, []);

    const handleAddItem = (event) => {
        event.preventDefault();

        const serviceIconFive = event.target.serviceIconFive.value;
        const serviceTitleFive = event.target.serviceTitleFive.value;
        const serviceDetailsFive = event.target.serviceDetailsFive.value;

        const itemSection = {

            serviceIconFive,
            serviceTitleFive,
            serviceDetailsFive,
        };

        const url = `https://aprilone-178ea8362c0b.herokuapp.com/service-item-five/${id}`;
        fetch(url, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(itemSection),
        })
            .then((res) => res.json())
            .then((result) => {

                alert(' Item is Updated');
            });
    };


    return (
        <>

        

            <div className='container  vh-100 d-flex align-items-center justify-content-center'>
                <form class="contact-form" onSubmit={handleAddItem}>
                    <div class="row">

                        <div className="col-lg-12 col-md-12 mb-3">
                            <div className="form-group">
                                <input type="text" className="form-control" name="serviceIconFive" defaultValue={item.serviceIconFive} placeholder="Service Image" required />
                            </div>
                        </div>

                        <div className="col-lg-12 col-md-12 mb-3">
                            <div className="form-group">
                                <input type="text" className="form-control" name="serviceTitleFive" defaultValue={item.serviceTitleFive} placeholder="Service Title" required />
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 mb-3">
                            <div className="form-group">
                                <input type="text" className="form-control" name="serviceDetailsFive" defaultValue={item.serviceDetailsFive} placeholder="Service Details" required />
                            </div>
                        </div>



                        <div class="slider-btn">
                            <button class="button-professional mb-5" data-animation="fadeInRight" data-delay=".8s"> Update service </button>
                        </div>
                    </div>

                </form>

            </div>

        </>
    );
};

export default EditServicesFive;